import { IIconProps } from "../types"

export default function IconUR4(props: IIconProps) {
  const width = props.size || props.width || (95 / 5) * 3
  const height = props.size || props.height || (112 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 95 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4406 1.46898C38.2991 0.539276 42.4477 0.119411 46.6864 0.749209C50.915 1.389 55.2336 3.07846 58.9125 6.0775C62.5913 9.08654 65.6403 13.4052 68.6394 17.7138C71.6484 22.0324 74.6074 26.351 77.6065 31.2594C80.6155 36.1679 83.6645 41.6661 85.9838 46.2346C88.313 50.8032 89.9225 54.442 91.1521 57.7409C92.3717 61.0399 93.2215 63.9989 93.5214 66.838C93.8113 69.6671 93.5614 72.3762 92.6716 75.1753C91.7819 77.9645 90.2624 80.8435 87.5533 84.4424C84.8442 88.0312 80.9554 92.3498 76.1769 96.6685C71.3885 100.977 65.7203 105.296 61.5716 107.965C57.4329 110.624 54.8038 111.644 50.4052 111.474C46.0066 111.304 39.8286 109.954 33.8205 108.085C27.8124 106.225 21.9743 103.856 16.8959 100.307C11.8176 96.7484 7.50895 92.01 4.75983 88.1612C2.00071 84.3124 0.821092 81.3534 0.521188 74.7955C0.231281 68.2376 0.821092 58.0808 2.22064 47.8841C3.6102 37.6874 5.80949 27.4506 8.47864 20.3429C11.1378 13.2352 14.2768 9.25648 18.6354 6.54735C22.984 3.83822 28.5722 2.39868 33.4406 1.46898Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
